module.exports = __webpack_public_path__ + "img/logo-dark.81c46a8e.svg";